export const Copyright = () => {
  return (
    <div className="border-t border-white/20">
      <div className="container mx-auto">
        <div className="py-6">
          <p className="text-base text-center">Copyright &copy; 2024 Bistro Café. All rights reserveds</p>
        </div>
      </div>
    </div>
  );
};
